export enum ActivityMode {
  Inperson = 'Inperson',
  Call = 'Call',
  VoiceMail = 'VoiceMail',
  Video = 'Video',
  Email = 'Email'
}
